import React from 'react';
import PropTypes from 'prop-types';
import {Badge, Icon, Tabs, Popover, Tooltip} from 'antd';
import {USER_UNREAD_MESSAGES_COUNT, USER_MESSAGES} from "../../profile/gql/query";
import styles from './index.less';
import {READ_MESSAGE} from "../../profile/gql/mutation";
import {FormattedMessage} from 'react-intl';
import {TabContent} from "./tab-content";

const TabPane = Tabs.TabPane;

export class NotifyBtn extends React.Component {
  static propTypes = {
    client: PropTypes.object.isRequired
  };

  static defaultProps = {
    loading: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      UnreadMessagesCount: null,
      UnreadMessages: [],
      SeenMessages: [],
      readFailed: false,
      deleteAll: false
    };
    this.loadMessages = this.loadMessages.bind(this);
  }

  componentWillMount() {
    this.loadUnreadMessageCount();
  }


  loadUnreadMessageCount() {
    if (this.state.UnreadMessagesCount === null) {
      this.props.client
        .query({query: USER_UNREAD_MESSAGES_COUNT})
        .then(({data: {userUnreadMessagesCount}}) => {
          this.setState({UnreadMessagesCount: userUnreadMessagesCount});
        }).catch(this.handleInternalError);
    }
  }


  clearAll() {
    this.setState({
      deleteAll: true,
    });
    this.state.UnreadMessages.map((message) => {
      this.readMessage(message.id)
    })
  }

  readMessage(message_ids, event) {
    if (message_ids.length) {
      this.props.client
        .mutate({
          mutation: READ_MESSAGE,
          variables: {ids: message_ids}
        })
        .then((res) => {
          let failed = false;
          res.data.readMessageByUser.result.map((result) => {
            if (!result.success) {
              failed = true;
            }
          });
          if (this.state.deleteAll) {
            this.setState({
              UnreadMessages: [],
              UnreadMessagesCount: 0,
              deleteAll: false
            });
            return
          }
          if (failed) {
            this.setState({
              readFailed: true
            });
          }
        }).catch(this.handleInternalError)
    }
  }


  getNotificationBox() {
    return (
      <div>
        <Tabs className={styles.tabs} defaultActiveKey="new" onChange={this.loadMessages}>
          <TabPane tab={<FormattedMessage id='layout.new-tab'/>} key="new">
            <TabContent
              data={this.state.UnreadMessages}
              onClick={this.readMessage.bind(this)}
            />
          </TabPane>
          <TabPane tab={<FormattedMessage id='layout.seen-tab'/>} key="read">
            <TabContent
              data={this.state.SeenMessages}
            />
          </TabPane>
        </Tabs>
        <div className='clear-btn' onClick={this.clearAll.bind(this)}>
          {<FormattedMessage id='layout.clear-notifications'/>}
        </div>
      </div>
    )
  }

  loadMessages(kind) {
    switch (kind) {
      case 'read':
        this.props.client
          .query({
            query: USER_MESSAGES,
            variables: {readOnly: true}
          })
          .then((res) => {
            if (!this.state.readFailed) {
              this.setState({
                UnreadMessages: [],
                UnreadMessagesCount: 0
              });
            }
            this.setState({SeenMessages: [...res.data.data]});
          }).catch(this.handleInternalError);
        break;
      // case 'all':
      //   this.props.client
      //     .query({
      //       query: USER_MESSAGES,
      //     })
      //     .then((res) => {
      //       this.setState({Messages: [...res.data.data]});
      //     }).catch(this.handleInternalError);
      //   break;
      default:
        this.props.client
          .query({
            query: USER_MESSAGES,
            variables: {newOnly: true}
          })
          .then((res) => {
            let newMessages = [];
            res.data.data.map((data) => {
              let exist = false;
              this.state.SeenMessages.map((seenMessage) => {
                if (seenMessage.id === data.id) {
                  exist = true
                }
              });
              if (!exist) {
                newMessages.push(data)
              }
            });
            this.setState({UnreadMessages: [...newMessages]});
          }).catch(this.handleInternalError);
        break;
    }
  }

  render() {
    const notificationBox = this.getNotificationBox();
    const badge = (
      <span className='user-notifications' onClick={this.loadMessages}>
        <Badge count={this.state.UnreadMessagesCount}>
          <Icon type="bell" className={styles.icon} style={{fontSize: 20}}/>
        </Badge>
      </span>
    );
    if (!notificationBox) {
      return badge;
    }
    return (
      <Tooltip placement='left' title={
          <FormattedMessage id="user-menu.notification" defaultMessage="Notification"/>
        }>
        <Popover
          popupClassName={styles.popover}
          placement="bottomRight"
          content={notificationBox}
          trigger="click"
          arrowPointAtCenter
        >
          {badge}
        </Popover>
      </Tooltip>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/layout/notifications/notify-popover.js